<template>
    <span class="gallery-thumbnail" :aria-busy="String(!imageUrl && !failed)" @click="retryIfFailed">
        <img v-if="imageUrl" :src="imageUrl" :alt="name" decoding="async" @error="onError">
        <span v-else-if="failed" class="gallery-thumbnail__message" role="status">
            <i class="fas fa-redo" aria-hidden="true"></i>
            Не удалось загрузить<br>Повторить
        </span>
        <span v-else class="gallery-thumbnail__placeholder" aria-label="Загрузка фотографии">
            <i class="far fa-image" aria-hidden="true"></i>
        </span>
    </span>
</template>

<script>
export default {
    name: 'GalleryThumbnail',
    inject: ['galleryImageLoader'],
    props: {src: {type: String, required: true}, name: {type: String, default: ''}},
    data: () => ({imageUrl: '', failed: false}),
    mounted() { this.register(); },
    beforeDestroy() { this.release(); },
    watch: {src() { this.release(); this.register(); }},
    methods: {
        register() {
            this.failed = false;
            this._imageJob = this.galleryImageLoader.register(this.$el, this.src, blob => {
                this.imageUrl = URL.createObjectURL(blob);
            }, this.onError);
        },
        release() {
            if (this._imageJob) this._imageJob.dispose();
            this._imageJob = null;
            this.clearImage();
        },
        clearImage() {
            if (this.imageUrl) URL.revokeObjectURL(this.imageUrl);
            this.imageUrl = '';
        },
        onError() { this.clearImage(); this.failed = true; },
        retryIfFailed(event) {
            if (!this.failed) return false;
            if (event) event.stopPropagation();
            this.failed = false;
            this._imageJob.retry();
            return true;
        }
    }
};
</script>

<style scoped>
.gallery-thumbnail { display: block; width: 100%; height: 100%; }
.gallery-thumbnail img { display: block; width: 100%; height: 100%; object-fit: cover; }
.gallery-thumbnail__placeholder, .gallery-thumbnail__message {
    display: flex; flex-direction: column; align-items: center; justify-content: center;
    width: 100%; height: 100%; gap: 6px; background: #f1f5f7; color: #657889;
}
.gallery-thumbnail__placeholder { font-size: 1.5rem; color: #a1b1bd; }
.gallery-thumbnail__message { padding: 6px; font-size: .75rem; line-height: 1.35; }
</style>
